import{m as e}from"./chunk-HBP5N4FR.js";e();function s({tokenId:n,erdLabel:r}){return Boolean(n&&n!==r)}export{s as a};
//# sourceMappingURL=chunk-7I7NVYZT.js.map
